import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { faAngleRight } from '@fortawesome/pro-regular-svg-icons';
import { getFormattedDate } from '../../../helpers/promotions-utils';
import useTranslation from '../../../hooks/use-translation';
import { StyledBaseButton } from '../../../styles/buttons';
import { StyledScreenReaderText } from '../../../styles/text';
import FontAwesomeComponent from '../../common/font-awesome-component';
import TableList from '../../common/table-list';
import Tooltip from '../tooltip';
const PromotionsTable = ({ displayPromotionsTableHeader, promotions, showDetailsModal, title }) => {
    const t = useTranslation();
    const promoBalanceHeader = t('promotions.promotionalBalanceHeader');
    const headers = [
        {
            id: 'description',
            text: t('promotions.descriptionTableHeader')
        },
        {
            id: 'purchase-date',
            text: t('promotions.purchaseDateTableHeader'),
            width: 120
        },
        {
            id: 'purchase-amount',
            text: t('promotions.purchaseAmountDateCellValue'),
            width: 120
        },
        {
            id: 'deferred-interest-charges',
            text: t('promotions.deferredInterestChargesTableHeader'),
            width: 175
        },
        {
            id: 'promotional-balance',
            text: (_jsxs(_Fragment, { children: [promoBalanceHeader, " ", _jsx(Tooltip, { isInteractive: true })] })),
            width: 150
        },
        {
            id: 'expiration-date',
            text: t('promotions.expirationDateTableHeader'),
            width: 120
        }
    ];
    const headersMaybeWithAction = [
        ...headers,
        { id: 'details-action', text: '', width: 40 }
    ];
    const header = headersMaybeWithAction.map(column => (_jsx(TableList.ColumnHeader, { width: column.width, children: column.text }, column.id)));
    return (_jsx(TableList, { header: header, hideHeader: !displayPromotionsTableHeader, title: title, children: promotions.map((promotion) => {
            const { description, purchaseDate, purchaseAmount, unbilledInterest, remainingBalance, expirationDate } = promotion;
            const formattedPurchaseDate = getFormattedDate({
                date: purchaseDate
            });
            const formattedExpirationDate = getFormattedDate({
                date: expirationDate,
                expirationDateLabel: t('promotions.untilPaidOffCellValue')
            });
            return (_jsxs(TableList.Row, { onClick: () => showDetailsModal(promotion), interactive: true, children: [_jsxs(TableList.Cell, { children: [_jsx(StyledScreenReaderText, { as: "h4", children: headers[0].text }), _jsx(StyledBaseButton, { fontSize: "root", fontWeight: "regular", textAlign: "left", children: description })] }), _jsxs(TableList.Cell, { children: [_jsx(StyledScreenReaderText, { as: "h4", children: headers[1].text }), formattedPurchaseDate] }), _jsxs(TableList.Cell, { children: [_jsx(StyledScreenReaderText, { as: "h4", children: headers[2].text }), `$${purchaseAmount}`] }), _jsxs(TableList.Cell, { children: [_jsx(StyledScreenReaderText, { as: "h4", children: headers[3].text }), `$${unbilledInterest}`] }), _jsxs(TableList.Cell, { children: [_jsx(StyledScreenReaderText, { as: "h4", children: promoBalanceHeader }), `$${remainingBalance}`] }), _jsxs(TableList.Cell, { children: [_jsx(StyledScreenReaderText, { as: "h4", children: headers[5].text }), formattedExpirationDate] }), _jsx(TableList.Cell, { children: _jsx(FontAwesomeComponent, { title: "View promotion details", icon: faAngleRight }) })] }, `${promotion.remainingBalance}-${promotion.description}`));
        }) }));
};
export default PromotionsTable;
//# sourceMappingURL=index.js.map